import React, { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import { useDarkMode } from '../stores/themeStore';

interface ThemeProviderProps {
  children: React.ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const { initializeTheme, isDark } = useDarkMode();

  useEffect(() => {
    // Initialize theme on app load
    initializeTheme();
  }, [initializeTheme]);

  return (
    <>
      {children}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme={isDark ? 'dark' : 'light'} // Dynamic theme based on current mode
        toastClassName={() =>
          `relative flex p-1 min-h-10 rounded-md justify-between overflow-hidden cursor-pointer ${
            isDark
              ? 'bg-xtnd-dark-800 text-xtnd-white'
              : 'bg-xtnd-white text-xtnd-dark'
          }`
        }
      />
    </>
  );
};

export default ThemeProvider; 